import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';


import { Observable } from 'rxjs';

import { ConnectorAuthService } from './connector-auth.service';


@Injectable({
    providedIn: 'root',
})
export class IdasAuthGuard implements CanActivate {
    constructor(
        private authService: ConnectorAuthService,
        private router: Router
    ) { }

    canActivate(): Observable<boolean> {

        if (this.authService.isLoggedIn) {
            return this.authService.isLoggedIn;
        } else {
            this.handleNotLoggedIn();
            return this.authService.isLoggedIn;
        }
    }

    // canActivate(): boolean {
    //     return true;
    // }

    private handleNotLoggedIn() {
        this.router.navigate(['/']);
    }
}
